import { Check } from 'lucide-react';

import { cn } from '@/lib/utils';

type Props = {
  steps: Array<{
    value: string;
    label: string;
  }>;
  activeStep: string;
  className?: string;
};

const BasicActivateProgressSteps = ({ steps, activeStep, className }: Props) => {
  const activeStepIndex = steps.findIndex((step) => step.value === activeStep);

  return (
    <div className={cn('flex relative items-center', className)}>
      <div className="flex grow">
        {steps.map(({ label, value }, index) => {
          const isActive = index === activeStepIndex;
          const isCompleted = index < activeStepIndex;

          return (
            <div key={value} className="group flex flex-col gap-1 flex-1 items-start py-0.5">
              <div
                className={cn(
                  'relative w-full flex justify-end group-first:justify-start group-last:after:right-3 after:absolute after:bg-input after:left-0 after:right-0 after:h-1 after:top-1/2 after:-translate-y-1/2 after:z-[0] before:absolute before:bg-muted-foreground before:h-1 before:w-1/2 before:left-0 before:top-1/2 before:-translate-y-1/2 before:z-[1] before:scale-0 before:transition-transform before:duration-150 before:ease-in-out group-last:before:hidden group-first:before:hidden',
                  isCompleted && 'after:bg-muted-foreground justify-start before:scale-100',
                  isActive &&
                    'justify-center group-last:justify-end group-last:after:bg-muted-foreground before:scale-100',
                )}
              >
                <div
                  className={cn(
                    'relative w-3.5 h-4.5 flex items-center justify-center before:size-full before:border-2 before:border-secondary-foreground before:rounded-full before:z-[1] before:absolute before:left-0 before:top-0 before:scale-0 before:transition-transform before:duration-150 before:ease-in-out',
                    isActive && 'w-4.5 before:scale-100',
                  )}
                >
                  <span
                    className={cn(
                      'relative size-3.5 bg-slate-300 rounded-full flex items-center justify-center z-[1]',
                      (isCompleted || isActive) && 'bg-secondary-foreground',
                      isActive && 'size-2.5',
                    )}
                  >
                    {isCompleted && <Check className="size-[10px] text-white" />}
                  </span>
                </div>
              </div>
              {isActive && <span className="text-[10px] text-foreground font-semibold">{label}</span>}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default BasicActivateProgressSteps;
